/* Santa's Little Jinglejest Store – theme scripts (no dependencies) */
(function () {
  'use strict';

  var T = window.theme || { routes: {}, strings: {} };
  T.routes = T.routes || {};
  T.strings = T.strings || {};
  T.mainHandle = T.mainHandle || 'kicking-santa-legs-hat';
  T.protHandle = T.protHandle || 'shipping-protection';
  T.prioHandle = T.prioHandle || 'priority-processing';
  T.routes.cart = T.routes.cart || '/cart';
  T.routes.cartJs = T.routes.cartJs || '/cart.js';
  T.routes.cartAdd = T.routes.cartAdd || '/cart/add.js';
  T.routes.cartChange = T.routes.cartChange || '/cart/change.js';
  var $ = function (s, ctx) { return (ctx || document).querySelector(s); };
  var $$ = function (s, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(s)); };

  function money(cents) {
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function' && T.moneyFormat) {
      try { return window.Shopify.formatMoney(cents, T.moneyFormat); } catch (e0) { /* fall through */ }
    }
    try {
      return new Intl.NumberFormat(T.locale || 'en-US', { style: 'currency', currency: T.currency || 'USD' }).format(cents / 100);
    } catch (e) {
      return '$' + (cents / 100).toFixed(2);
    }
  }

  function request(url, opts) {
    opts = opts || {};
    opts.headers = { 'Content-Type': 'application/json', 'Accept': 'application/json' };
    return fetch(url, opts).then(function (r) {
      return r.json().then(function (data) {
        if (!r.ok) { throw data; }
        return data;
      }, function () {
        throw {}; /* non-JSON error page: caller shows the generic error string */
      });
    });
  }
  function post(url, body) { return request(url, { method: 'POST', body: JSON.stringify(body) }); }
  function getCart() { return request(T.routes.cartJs + '?_=' + Date.now()); }

  function hasHandle(cart, handle) {
    return cart.items.some(function (i) { return i.handle === handle; });
  }
  function isAddon(i) { return i.handle === T.protHandle || i.handle === T.prioHandle; }

  /* ---------------------------------------------------------------
     Add-on guard (Shipping Protection + Priority Processing): add-ons can
     never be bought alone and are always quantity 1.
     If the cart has an add-on but no main product, remove it.
  ---------------------------------------------------------------- */
  function guard(cart) {
    var hasMain = hasHandle(cart, T.mainHandle);
    var prots = cart.items.filter(isAddon);
    if (!prots.length) { return Promise.resolve({ cart: cart, changed: false }); }
    var chain = Promise.resolve(cart);
    var changed = false;
    prots.forEach(function (i) {
      if (!hasMain) {
        changed = true;
        chain = chain.then(function () { return post(T.routes.cartChange, { id: i.key, quantity: 0 }); });
      } else if (i.quantity !== 1) {
        changed = true;
        chain = chain.then(function () { return post(T.routes.cartChange, { id: i.key, quantity: 1 }); });
      }
    });
    return chain.then(function (c) { return { cart: c, changed: changed }; });
  }

  function applyCart(cart) {
    $$('[data-cart-count]').forEach(function (el) { el.textContent = cart.item_count; });
    var hasMain = hasHandle(cart, T.mainHandle);
    $$('[data-checkout-form]').forEach(function (el) { el.hidden = !hasMain; });
    $$('[data-checkout]').forEach(function (el) { el.disabled = !hasMain; });
    $$('[data-need-main]').forEach(function (el) { el.hidden = hasMain; });
  }

  function refresh() {
    return getCart()
      .then(function (cart) {
        /* hide checkout immediately if an add-on is alone, even if the cleanup below fails */
        applyCart(cart);
        return guard(cart);
      })
      .then(function (res) {
        applyCart(res.cart);
        try { document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: res.cart, changed: res.changed } })); } catch (e1) { /* old browser */ }
        return res;
      })
      .catch(function () { /* silent */ });
  }

  /* shared with assets/cart-drawer.js */
  window.themeCart = { getCart: getCart, guard: guard, hasHandle: hasHandle, applyCart: applyCart, refresh: refresh };

  /* ---------------------------------------------------------------
     Cart page interactions
  ---------------------------------------------------------------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest ? e.target.closest('[data-qty]') : null;
    if (!btn) { return; }
    e.preventDefault();
    btn.disabled = true;
    post(T.routes.cartChange, { id: btn.getAttribute('data-key'), quantity: parseInt(btn.getAttribute('data-qty'), 10) })
      .then(function () { return refresh(); })
      .then(function () { btn.disabled = false; }, function () { btn.disabled = false; });
  });

  var ADDON_ATTRS = [
    { attr: 'data-add-protection', handle: function () { return T.protHandle; } },
    { attr: 'data-add-priority', handle: function () { return T.prioHandle; } }
  ];
  document.addEventListener('change', function (e) {
    var box = e.target;
    if (!box.matches || !box.checked) { return; }
    var def = ADDON_ATTRS.filter(function (a) { return box.matches('[' + a.attr + ']'); })[0];
    if (!def) { return; }
    var handle = def.handle();
    box.disabled = true;
    /* re-check the live cart: add-ons are only allowed together with the main product, qty 1 */
    getCart()
      .then(function (cart) {
        if (!hasHandle(cart, T.mainHandle)) { throw new Error('no main'); }
        if (hasHandle(cart, handle)) { return null; }
        return post(T.routes.cartAdd, { items: [{ id: parseInt(box.getAttribute(def.attr), 10), quantity: 1 }] });
      })
      .then(function () { return refresh(); })
      .catch(function () { box.disabled = false; box.checked = false; refresh(); });
  });

  /* ---------------------------------------------------------------
     Product form: required bundle + optional add-ons in ONE add call
  ---------------------------------------------------------------- */
  $$('[data-product-form]').forEach(function (form) {
    var radios = $$('input[name="bundle_qty"]', form);
    var idInput = $('input[name="id"]', form);
    var bundles = $('#bundles', form);
    var unit = bundles ? parseInt(bundles.getAttribute('data-unit'), 10) || 0 : 0;
    var prot = $('#prot', form);
    var prio = $('#prio', form);
    var addons = [
      { el: prot, id: 'data-prot-id', price: 'data-prot-price' },
      { el: prio, id: 'data-prio-id', price: 'data-prio-price' }
    ].filter(function (a) { return a.el; });
    var stickyEl = $('[data-sticky-price]');
    var stickyLab = $('[data-sticky-label]');
    var stickyName = stickyLab ? stickyLab.textContent.replace(/^\s*\d+\s*\S+\s*/, '') : '';
    var msg = $('[data-msg]');

    function selected() { return radios.filter(function (r) { return r.checked; })[0]; }
    /* a bundle is REQUIRED: if none is selected (should be impossible), fall back to Buy 2 */
    function ensureBundle() {
      var sel = selected();
      if (sel || !radios.length) { return sel; }
      var pick = radios.filter(function (r) { return r.value === '2' && !r.disabled; })[0] ||
        radios.filter(function (r) { return !r.disabled; })[0];
      if (pick) { pick.checked = true; }
      return pick;
    }
    function totalFor(r) {
      var q = parseInt(r.getAttribute('data-qty-opt'), 10) || 1;
      var d = parseFloat(r.getAttribute('data-discount')) || 0;
      return { strike: unit * q, total: q * (unit - Math.floor(unit * d / 100)) };
    }

    function update() {
      var sel = ensureBundle();
      addons.forEach(function (a) {
        var lab = a.el.closest ? a.el.closest('label') : null;
        if (lab) { lab.classList.toggle('on', a.el.checked); }
      });
      radios.forEach(function (r) {
        var label = r.closest('label');
        if (label) {
          label.classList.toggle('sel', r === sel);
          var t = totalFor(r);
          var tEl = $('[data-card-total]', label);
          var sEl = $('[data-card-strike]', label);
          if (tEl) { tEl.textContent = money(t.total); }
          if (sEl) { sEl.textContent = money(t.strike); }
        }
      });
      if (!sel) { return; }
      var extra = 0;
      addons.forEach(function (a) { if (a.el.checked) { extra += parseInt(a.el.getAttribute(a.price), 10) || 0; } });
      if (stickyEl) { stickyEl.textContent = money(totalFor(sel).total + extra); }
      if (stickyLab) { stickyLab.textContent = (parseInt(sel.value, 10) || 1) + ' × ' + stickyName; }
    }
    radios.forEach(function (r) { r.addEventListener('change', update); });
    addons.forEach(function (a) { a.el.addEventListener('change', update); });
    update();

    var soldOut = radios.length > 0 && radios.every(function (r) { return r.disabled; });
    var busyNow = false;
    var mainBtn = $('[data-add-btn]', form);
    var soldText = mainBtn ? mainBtn.textContent : '';
    function setBusy(busy) {
      busyNow = busy;
      $$('[data-add-btn]').forEach(function (b) {
        b.disabled = busy || soldOut;
        b.textContent = soldOut ? soldText : (busy ? T.strings.adding : T.strings.addToCart);
        b.setAttribute('aria-busy', busy ? 'true' : 'false');
      });
    }
    if (soldOut) { setBusy(false); }
    function say(html, isError) {
      if (!msg) { return; }
      msg.className = 'msg' + (isError ? ' err' : '');
      if (isError) { msg.textContent = html; } else { msg.innerHTML = html; }
    }

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (busyNow || soldOut) { return; }
      var sel = ensureBundle();
      if (!sel || !idInput) { say(T.strings.error, true); return; }
      var mainId = parseInt(idInput.value, 10);
      if (!mainId) { say(T.strings.error, true); return; }
      var items = [{ id: mainId, quantity: parseInt(sel.value, 10) || 1 }];
      addons.forEach(function (a) {
        var vid = parseInt(a.el.getAttribute(a.id), 10);
        if (a.el.checked && vid) { items.push({ id: vid, quantity: 1 }); }
      });
      var trigger = e.submitter || document.activeElement;
      setBusy(true);
      say('', false);
      /* add-ons already in the cart are not re-sent (they would bump to qty 2 and need a cleanup) */
      getCart()
        .then(function (cart) {
          var inCart = cart.items.map(function (i) { return i.variant_id; });
          var mainItem = items[0];
          return [mainItem].concat(items.slice(1).filter(function (it) { return inCart.indexOf(it.id) === -1; }));
        }, function () { return items; })
        .then(function (send) { return post(T.routes.cartAdd, { items: send }); })
        .then(function () { return refresh(); })
        .then(function () { return getCart(); })
        .then(function (cart) {
          applyCart(cart);
          setBusy(false);
          /* the cart drawer (if present) takes over and opens; otherwise show the inline message */
          var evt = null;
          try { evt = new CustomEvent('cart:added', { cancelable: true, detail: { cart: cart, trigger: trigger } }); } catch (e2) { evt = null; }
          if (evt && !document.dispatchEvent(evt)) { return; }
          say('✅ ' + T.strings.added, false);
        })
        .catch(function (err) {
          setBusy(false);
          say((err && typeof err.description === 'string' && err.description) || T.strings.error, true);
        });
    });
  });

  /* Gallery thumbnails */
  $$('[data-gallery] .thumbs img').forEach(function (thumb) {
    function pick() {
      var main = $('#main-image');
      if (main) {
        main.removeAttribute('srcset');
        main.removeAttribute('sizes');
        main.src = thumb.getAttribute('data-full') || thumb.src;
        if (thumb.alt) { main.alt = thumb.alt; }
      }
      $$('[data-gallery] .thumbs img').forEach(function (x) { x.classList.toggle('on', x === thumb); });
    }
    thumb.addEventListener('click', pick);
    thumb.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); pick(); }
    });
  });

  /* Snow effect */
  var snow = $('#snow');
  if (snow && !(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches)) {
    var count = parseInt(snow.getAttribute('data-count'), 10) || 30;
    for (var i = 0; i < count; i++) {
      var f = document.createElement('i');
      f.textContent = '❄';
      f.style.left = Math.random() * 100 + '%';
      f.style.fontSize = 10 + Math.random() * 14 + 'px';
      f.style.animationDuration = 6 + Math.random() * 8 + 's';
      f.style.animationDelay = -Math.random() * 10 + 's';
      snow.appendChild(f);
    }
  }

  /* Initial pass on every page: sync count and enforce the add-on rules */
  refresh();
})();
